import { tv } from "tailwind-variants";

export const description = tv({
    base: ["tw:w-full tw:pb-px tw:overflow-y-hidden tw:truncate"]
});
